/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { VendorService } from './services/vendor.service';
import { ProductService } from './services/product.service';
import { DatasetService } from './services/dataset.service';
import { CompanyService } from './services/company.service';
import { ProfileService } from './services/profile.service';
import { DictionaryService } from './services/dictionary.service';
import { AiService } from './services/ai.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    VendorService,
    ProductService,
    DatasetService,
    CompanyService,
    ProfileService,
    DictionaryService,
    AiService,
    ApiConfiguration
  ],
})
export class PublicApiModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<PublicApiModule> {
    return {
      ngModule: PublicApiModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: PublicApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('PublicApiModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
